/**
 * Singular dynamic links: open the app if installed, otherwise redirect to the
 * App Store / Play Store (per platform) automatically. One link per surface so
 * installs stay attributable to the CTA that drove them.
 */
export const APP_LINK = 'https://links.openigloo.com/Eqsnv/hb8y0/2t85';
export const UNLOCK_MAP_APP_LINK = 'https://links.openigloo.com/Eqsnv/b5ye/v28f';
// Footer "Get the Openigloo app" section — both store badges and the QR code
// resolve to this link, so the QR image must stay in sync with it.
export const APP_DOWNLOAD_LINK = 'https://links.openigloo.com/Eqsnv/klbp/30t3';

export function openAppLink(link: string) {
  window.open(link, '_blank', 'noopener,noreferrer');
}
